import { Blockquote, Inset, Text } from "@radix-ui/themes";


export default function Y2025M09a() {

  return (
    <>
      <div className="container py-5">
        <div className='row'>

          <div className='col-lg-4'>
            <Inset clip="padding-box" side="top" pb="current">
              <img
                src="https://www.shadvala.org/img/interstices-2025-09-02.jpg"
                alt="Events"
                style={{
                  display: 'block',
                  objectFit: 'cover',
                  width: '100%',
                  height: '100%',
                  backgroundColor: 'var(--gray-5)',
                }}
              />
              <Text as="p" mb="5" size="2">
                Photo by Adrián Navigante
              </Text>
            </Inset>
          </div>

          <div className='col-lg-8'>
            <div className="container">
              <div className='row py-3 border-top'>
                <div className='col'>
                  <Text as="p" mb="5" size="2" weight="bold">
                    September 2025, Togoville (Togo)
                  </Text>
                </div>
              </div>
              <div className='row pb-3'>
                <div className='col'>
                  <Blockquote size="4" color>
                    Research Work in West-Africa: <i>The Divination System of the Ewe in Togo</i>
                  </Blockquote>
                </div>
              </div> 
              <div className='row pb-3'>
                <div className='col'>
                  <Text as="p" mb="5" size="3">
                    This research stay of Adrián Navigante in Southern Togo entailed intensive activities related to the geomantic system of divination, its mythical and ritual structure as well as its application as a healing dispositive. Such activities intend to continue and deepen the project began at the Alain Daniélou Foundation five years ago and valorize traditional local cultures, their presence and persistence in the global context.
                  </Text>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  )
}
